<template>
    <tasks-dialog :visible.sync="visible"  @closed="handleCloseDialog" />
 </template>
 
 <script>
 import { ConfirmComponent } from '../common/service-dialog/confirm';
 import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';
 import { TASKS_DIALOG as TasksDialog } from '@zoom/billing-shared';
 
 export default {
 name: 'TasksLearnMoreDialog',
 mixins: [ConfirmComponent],
 components: {
    TasksDialog
   },
 data () {
   return {
     visible: false,
   };
 },
 watch: {
   visible(val) {
     if (this.$context.is.modal) {
       val ? hideModalDialogCloseButton() : showModalDialogCloseButton();
     }
   }
 },
 mounted () {
 },
 beforeDestroy () {
 },
 methods: {
   handleCloseDialog () {
     this.visible = false;
   },
 },
 };
 </script>
 